import { css } from "@emotion/react";
import React, { useEffect, useState } from "react";
import { useTrelloPowerUpContext } from "../../../external/trello-pu__core/trello-iframe/context";
import fontStylesNew from "../../styles/font-styles-new";
import trelloColors from "../../styles/trello-colors";
import ConditionalRender from "../shared/components/conditional-renderer";
import useBoardTargets from "../shared/hooks/use-board-targets";
// import { trackButtonClick, trackLinkClick } from "../shared/tracking/tracking";
import BoardTargetsList from "./board-targets-list";
import TargetsAdder from "./targets-adder";

const Main = () => {
  const { trelloIFrame } = useTrelloPowerUpContext();
  const [boardTargets, addTarget, removeTarget] = useBoardTargets();
  const [isAttachmentsSectionOn, setIsAttachmentsSectionOn] = useState<
    boolean | null
  >(null);

  useEffect(() => {
    trelloIFrame
      .get("card", "shared", "isOpen")
      .then(setIsAttachmentsSectionOn);
  }, [trelloIFrame]);

  useEffect(() => {
    trelloIFrame.sizeTo("#card-button");
  }, [boardTargets, isAttachmentsSectionOn, trelloIFrame]);

  useEffect(() => {
    if (isAttachmentsSectionOn !== null) {
      trelloIFrame.set("card", "shared", "isOpen", isAttachmentsSectionOn);
    }
  }, [isAttachmentsSectionOn, trelloIFrame]);

  function enableBulkCardsAttachmentsHandler(value) {
    // trackButtonClick("EnableBulkCardsAttachments", {
    //   category: "BulkCardsAttachments",
    //   value,
    //   idCard: trelloIFrame.getContext().card,
    // });
    setIsAttachmentsSectionOn(value);
  }

  return (
    <div css={styles.container} id="card-button">
      <div css={styles.sectionTitle}>Enabling</div>
      <span css={[styles.enableInput, styles.topMargin]}>
        Enable&nbsp;<b>Links</b>&nbsp;on this card?&nbsp;&nbsp;
        <input
          css={styles.checkbox}
          type={"checkbox"}
          checked={!!isAttachmentsSectionOn}
          onChange={(e) => enableBulkCardsAttachmentsHandler(e.target.checked)}
        />
      </span>
      <ConditionalRender
        condition1={!!isAttachmentsSectionOn}
        renderIf1True={
          <React.Fragment>
            <div css={styles.sectionTitle}>Board targets</div>
            <TargetsAdder onSubmit={addTarget} />
            <BoardTargetsList
              targets={boardTargets}
              onRemoveClick={removeTarget}
            />
          </React.Fragment>
        }
      />
      {/* <div css={[styles.note]}>Note: You need to add one or more Trello Cards as attachments to this cards to see the view.</div> */}
      <div css={[styles.note, styles.topMargin]}>
        Note: At least one Trello Card needed as an attachment on this card for
        the view to be displayed.&nbsp;
        <a
          // onClick={() =>
          //   trackLinkClick("LearnMoreFromCardAttachmentCardButton", {
          //     category: "Info",
          //     name: "BulkCardsAttachments",
          //   })
          // }
          href={
            "https://axoshift.netlify.app/bulk-actions-intro#depenenciesrelationships-tracking"
          }
          target="_blank"
          rel="noreferrer"
        >
          Learn more.
        </a>
      </div>
    </div>
  );
};

export default Main;

const styles = {
  container: css`
    display: flex;
    flex-direction: column;
  `,
  sectionTitle: css`
    ${fontStylesNew.smallUpperCase};
    color: ${trelloColors.N300};
    :not(:first-of-type)& {
      margin-top: 16px;
    }
  `,
  checkbox: css`
    input[type="checkbox"]& {
      margin: 0;
    }
  `,
  topMargin: css`
    margin-top: 16px;
  `,
  enableInput: css`
    display: flex;
    align-items: center;
  `,
  note: css`
    ${fontStylesNew.verySmallRegular}
    text-align: start;
    margin-top: 4px;
  `,
};
